// extracted by mini-css-extract-plugin
export default {"listContainer":"factor-list_listContainer__FGA3z","listItem":"factor-list_listItem__vKX1D"};